import { getEntityById } from './selectorUtils';

export function answersSelector(state, questions) {
  let answersForBlock = {};
  questions.forEach(question => {
    const answer = answerSelector(state, question.id);
    if (answer !== null) {
      answersForBlock[question.id] = answer;
    }
  });
  return answersForBlock;
}

export function answerSelector(state, question_id) {
  return getEntityById(state, 'answers', question_id);
}



// WEBPACK FOOTER //
// ./src/selectors/answerSelectors.js